import { getString } from "../../common/common";

export const IF_HEADING1 = "IF_HEADING1";
export const IF_HEADING2 = "IF_HEADING2";
export const IF_P1 = "IF_P1";
export const IF_HEADING3 = "IF_HEADING3";
export const IF_LI1 = "IF_LI1";
export const IF_LI2 = "IF_LI2";
export const IF_LI3 = "IF_LI3";
export const IF_LI4 = "IF_LI4";
export const IF_LI5 = "IF_LI5";
export const IF_LI6 = "IF_LI6";
export const IF_LI7 = "IF_LI7";
export const IF_LI8 = "IF_LI8";
export const IF_LI9 = "IF_LI9";
export const IF_LI10 = "IF_LI10";
export const IF_LI11 = "IF_LI11";
export const IF_LI12 = "IF_LI12";
export const IF_LI13 = "IF_LI13";
export const IF_LI14 = "IF_LI14";
export const IF_LI15 = "IF_LI15";
export const IF_LI16 = "IF_LI16";
export const IF_LI17 = "IF_LI17";
export const IF_LI18 = "IF_LI18";
export const IF_LI19 = "IF_LI19";

export const translations = {
  en: {
    [IF_HEADING1]: "Infrastructure & Facility",
    [IF_HEADING2]: "KSRTC Infrastructure & Facilities",
    [IF_P1]:
      "KSRTC infrastructure include Corporate Office, Divisional Offices, depots, bus stations, Divisional Work Shops, Regional Workshops, Printing Press, Hospitals, training institutes, Officers/Employees Quarters and one Sports Complex.",
    [IF_HEADING3]: "Facilities at KSRTC Bus Stations",
    [IF_LI1]: "All transport facilities under one roof",
    [IF_LI2]: "Modern High-Tech Bus stations",
    [IF_LI3]: "Drinking Water",
    [IF_LI4]: "Seating Arrangements",
    [IF_LI5]: "Modern Toilets",
    [IF_LI6]: "Canteen Facilities",
    [IF_LI7]: "Reservation Counters",
    [IF_LI8]: "Pre-paid taxi",
    [IF_LI9]: "ATM facilities",
    [IF_LI10]: "Pre-paid auto rickshaw",
    [IF_LI11]: "Dust-proof Parking Area",
    [IF_LI12]: "Two Wheelers and Four Wheelers Parking Facility",
    [IF_LI13]: "Digital Display and Intelligent Transport System",
    [IF_LI14]: "Public Addressing System",
    [IF_LI15]: "Commercial Establishments and Offices",
    [IF_LI16]: "Tourist Information System",
    [IF_LI17]: "Crew Rest Room",
    [IF_LI18]: "Modern Lighting Facilities",
    [IF_LI19]: "Cloak Rooms",
  },
  kn: {
    [IF_HEADING1]: "ಮೂಲಸೌಕರ್ಯ ಮತ್ತು ಸೌಲಭ್ಯ",
    [IF_HEADING2]: "KSRTC ಮೂಲಸೌಕರ್ಯ ಮತ್ತು ಸೌಲಭ್ಯಗಳು",
    [IF_P1]:
      "KSRTC ಮೂಲಸೌಕರ್ಯವು ಕಾರ್ಪೊರೇಟ್ ಕಚೇರಿ, ವಿಭಾಗೀಯ ಕಚೇರಿಗಳು, ಡಿಪೋಗಳು, ಬಸ್ ನಿಲ್ದಾಣಗಳು, ವಿಭಾಗೀಯ ಕಾರ್ಯಾಗಾರಗಳು, ಪ್ರಾದೇಶಿಕ ಕಾರ್ಯಾಗಾರಗಳು, ಮುದ್ರಣಾಲಯ, ಆಸ್ಪತ್ರೆಗಳು, ತರಬೇತಿ ಸಂಸ್ಥೆಗಳು, ಅಧಿಕಾರಿಗಳು/ಉದ್ಯೋಗಿಗಳ ವಸತಿಗೃಹಗಳು ಮತ್ತು ಒಂದು ಕ್ರೀಡಾಂಗಣವಿರುತ್ತದೆ.",
    [IF_HEADING3]: "KSRTC ಬಸ್ ನಿಲ್ದಾಣಗಳಲ್ಲಿನ  ಸೌಲಭ್ಯಗಳು",
    [IF_LI1]: "ಒಂದೇ ಜಾಗದಲ್ಲಿ ಎಲ್ಲಾ ಸಾರಿಗೆ ಸೌಲಭ್ಯಗಳು",
    [IF_LI2]: "ಆಧುನಿಕ ಹೈಟೆಕ್ ಬಸ್ ನಿಲ್ದಾಣಗಳು",
    [IF_LI3]: "ಕುಡಿಯುವ ನೀರು",
    [IF_LI4]: "ಕುಳಿತುಕೊಳ್ಳುವ ವ್ಯವಸ್ಥೆಗಳು",
    [IF_LI5]: "ಆಧುನಿಕ ಶೌಚಾಲಯಗಳು",
    [IF_LI6]: "ಕ್ಯಾಂಟೀನ್ ಸೌಲಭ್ಯಗಳು",
    [IF_LI7]: "ರಿಸರ್ವೇಷನ್ ಕೌಂಟರ್‌ಗಳು",
    [IF_LI8]: "ಪ್ರೀಪೇಯ್ಡ್ ಟ್ಯಾಕ್ಸಿ",
    [IF_LI9]: "ಎಟಿಎಂ ಸೌಲಭ್ಯಗಳು",
    [IF_LI10]: "ಪ್ರೀಪೇಯ್ಡ್ ಆಟೋ ರಿಕ್ಷಾ",
    [IF_LI11]: "ಧೂಳು ಇಲ್ಲದಂತಹ ಪಾರ್ಕಿಂಗ್ ಪ್ರದೇಶ",
    [IF_LI12]: "ದ್ವಿಚಕ್ರ ವಾಹನಗಳು ಮತ್ತು ನಾಲ್ಕು ಚಕ್ರಗಳ ಪಾರ್ಕಿಂಗ್ ಸೌಲಭ್ಯ",
    [IF_LI13]: "ಡಿಜಿಟಲ್ ಡಿಸ್ಪ್ಲೇ ಮತ್ತು ಇಂಟೆಲಿಜೆಂಟ್ ಟ್ರಾನ್ಸ್ಪೋರ್ಟ್ ಸಿಸ್ಟಮ್",
    [IF_LI14]: "ಸಾರ್ವಜನಿಕ ವಿಳಾಸ ವ್ಯವಸ್ಥೆ",
    [IF_LI15]: "ವಾಣಿಜ್ಯ ಸಂಸ್ಥೆಗಳು ಮತ್ತು ಕಛೇರಿಗಳು",
    [IF_LI16]: "ಪ್ರವಾಸಿ ಮಾಹಿತಿ ವ್ಯವಸ್ಥೆ",
    [IF_LI17]: "ಸಿಬ್ಬಂದಿ ವಿಶ್ರಾಂತಿ ಕೊಠಡಿ",
    [IF_LI18]: "ಆಧುನಿಕ ಬೆಳಕಿನ ಸೌಲಭ್ಯಗಳು",
    [IF_LI19]: "ಸಾಮಾನು ಇಡುವ ಕೊಠಡಿ/ಕ್ಲಾಕ್ ಕೊಠಡಿಗಳು",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
